import { useState } from "react";
import Cross from "../../assets/icons/Cross";
import DefaultButton from "../default-button/DefaultButton";
import ArrowLeft from "../../assets/icons/ArrowLeft";
import Tick from "../../assets/icons/Tick";
import InputField from "../input-field/InputField";

interface AddCourseModalProps {
    isOpen: boolean;
    onClose: () => void;
    onSubmit: (courseName: string) => void;
}

export default function AddCourseModal({
    isOpen,
    onClose,
    onSubmit
}: AddCourseModalProps) {
    const [courseName, setCourseName] = useState("");

    const handleSubmit = () => {
        if (courseName.trim()) {
            onSubmit(courseName.trim());
            handleClose();
        }
    };

    const handleClose = () => {
        setCourseName("");
        onClose();
    };

    const validateForm = (): boolean => {
        return Boolean(courseName.trim());
    };

    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div className="w-fit p-8 rounded-xl bg-white text-black absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 flex flex-col">
                <div>
                    <div
                        onClick={handleClose}
                        className="flex justify-end cursor-pointer"
                    >
                        <Cross additionalStyle="text-[#5F6B88]" />
                    </div>
                    <p className="text-black font-normal text-[24px]">
                        Добавление курса
                    </p>
                </div>

                <div className="flex-grow mt-8">
                    <p className="mb-2 font-medium text-[15px] text-[#5F6B88]">
                        Название курса
                    </p>
                    <InputField
                        type="text"
                        value={courseName}
                        handleChange={(e) => setCourseName(e.target.value)}
                        placeholder="Введите название курса"
                        additionalClassName="bg-[#F0F3FA] py-3 px-4 text-valley-black rounded-lg"
                    />
                </div>

                <div className="grid grid-cols-[5fr_7fr] gap-3 mt-4">
                    <DefaultButton
                        buttonText="Вернуться"
                        additionalStyle="bg-[#5F6B88] text-white px-8 py-3 text-nowrap"
                        Icon={ArrowLeft}
                        onClick={handleClose}
                    />
                    <DefaultButton
                        buttonText="Добавить курс"
                        additionalStyle={`bg-valley-dark-green text-white px-8 py-3 text-nowrap ${
                            !validateForm() ? 'opacity-30' : ''
                        }`}
                        Icon={Tick}
                        onClick={handleSubmit}
                        disabled={!validateForm()}
                    />
                </div>
            </div>
        </div>
    );
}

